type UseYearRangeResult = {
  years: number[];
  startOptions: number[];
  endOptions: number[];
  startValue: number;
  endValue: number;
};

export default function useYearRange(
  filterOptions: any,
  globalFilters: { yearRange: [number, number] }
): UseYearRangeResult {
  const minYear = filterOptions?.yearRangeLimits?.min ?? 2012;
  const maxYear = filterOptions?.yearRangeLimits?.max ?? 2025;
  const years: number[] =
    filterOptions?.dealYears && filterOptions.dealYears.length
      ? Array.from(new Set(filterOptions.dealYears))
          .map((v: any) => parseInt(v as any, 10))
          .filter((y: number) => !Number.isNaN(y) && y >= minYear && y <= maxYear)
          .sort((a: number, b: number) => a - b)
      : [];

  const startOptions = years.filter((y) => y < globalFilters.yearRange[1]);
  const endOptions = years.filter((y) => y > globalFilters.yearRange[0]);
  const startValue = startOptions.includes(globalFilters.yearRange[0])
    ? globalFilters.yearRange[0]
    : (startOptions[0] ?? globalFilters.yearRange[0]);
  const endValue = endOptions.includes(globalFilters.yearRange[1])
    ? globalFilters.yearRange[1]
    : (endOptions[endOptions.length - 1] ?? globalFilters.yearRange[1]);

  return { years, startOptions, endOptions, startValue, endValue };
}
